import _extends from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
import _objectWithoutProperties from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
const _excluded = ["size", "color"];
var __jsx = React.createElement;
import React from "react";
const PlaneLand = _ref => {
  let {
      size = "16",
      color = "currentColor"
    } = _ref,
    attributes = _objectWithoutProperties(_ref, _excluded);
  return __jsx("svg", _extends({
    width: size,
    height: size,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, attributes), __jsx("path", {
    d: "M12.5616 11.387C12.8335 11.4487 13.1169 11.3935 13.3521 11.2329C13.5874 11.0723 13.7561 10.8189 13.8229 10.5259V10.5252C13.8568 10.3766 13.8634 10.2221 13.8423 10.0707C13.8211 9.9193 13.7728 9.77389 13.6999 9.6428C13.627 9.51172 13.5311 9.39752 13.4175 9.30674C13.304 9.21596 13.1751 9.15038 13.0382 9.11376L9.98757 8.29324L6.55024 3.35856L5.06757 3.19562L7.02157 7.96735L4.05557 7.64219L2.51424 4.86924L1.59424 5.09374L2.4209 9.09131L12.5616 11.387ZM2.00024 13.3452H14.0002V14.7936H2.00024V13.3452Z",
    fill: color
  }));
};
export default PlaneLand;